import ListOrdersWrap from './ListOrdersWrap';
export default ListOrdersWrap;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/index.ts